import './App.css';
import profileHoliday from './profile_hi.PNG';
import husky from './husky.png';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={profileHoliday} className="App-logo" alt="logo" />
        <h1>Amey Parundekar</h1>
        <div className="desc">
        <div style={{"text-align": "center"}}> 
        <a href="mailto:amey@gatech.edu"><i class="fa-solid fa-envelope"></i></a> <a href="https://linkedin.com/in/thelostexplorer"><i class="fa-brands fa-linkedin"></i></a> <a href="https://github.com/the-lost-explorer"><i class="fa-brands fa-github-square"></i></a> <a href="https://medium.com/@4m3y"><i class="fa-brands fa-medium"></i></a> <a href="https://twitter.com/AmeyParundekar"><i class="fa-brands fa-twitter-square"></i></a> <a href="https://scholar.google.com/citations?user=eMy5X6EAAAAJ&hl=en"><i class="fa-solid fa-graduation-cap"></i></a>
        <br/> </div>
        <h3>About</h3>
        <p>
          I am an ECE grad student at <a href="https://ece.gatech.edu">Georgia Institute of Technology</a>. 
          I live in Metz, France at Tech's European campus. I study systems, control, signals and AI for robotics. My special interests lie in sensor-based autonomous control of mobile vehicles.
          You can find my resume <a href="https://drive.google.com/file/d/1Ga9ka_ZXCwRjZ3yabMk1wWOhmjKPFBNE/view">here</a>.
        </p>      
        <p>I am currently working on evaluation of <a href="https://hal.inria.fr/hal-03286432">Multi-Sensor-Based Predictive Control for Autonomous Parking</a> with <a href="https://research.gatech.edu/cedric-pradalier">Dr. Cédric Pradalier</a> at DREAM lab in Georgia Tech Lorraine. 
          I am also a graduate teaching assistant for <a href="https://www.ece.gatech.edu/courses/course_outline/ECE3741">ECE3741</a> in <a href="https://lorraine.gatech.edu/faculty-staff/suresh-sundaram">Dr. Suresh Sundaram's</a> lab at <a href="https://umi2958.gatech.edu/our-partnerships/institut-lafayette">Institut Lafayette</a> during Spring 2022.</p>
        <p>I also have experience working as a software developer in AR/VR at <a href="https://gmetri.com">GMetri</a> and internships at <a href="https://ptc.com">PTC</a> and <a href="https://hasura.io">Hasura</a>.</p>
        
        <h3>Recent Updates</h3>

        <b>January, 2022</b> <br/><br/>

        In Fall 2021, I started working on sensor-based-control for non-holonomic robots under Dr Cédric Pradalier at Georgia Tech. 
        The goal is to evaluate <a href="https://hal.inria.fr/hal-03286432">this</a> paper by recreating a similar approach for autonomous parking using a Husky robot.
        So far we have been working on simulating a sensor-based servoing approach for go-to-goal, go-to-goal with orientation and a line convergence control. 
        We utlised several techniques inspired from visual servoing, visual servoing for lines and camera pose estimation for lines to come up with a control approach that does not depend on cameras as a sensor.
        We also came up with a hybrid switching approach to tackle the problem of applied sensor based feedback control making the robot get stuck in a local minima which makes it converge to an incorect goal. 
        This utilised simple state machines that I learnt from the course on Theory of Computation. <br/><br/>
        <img src={husky} className="App-logo" alt="logo" />
        <br/><br/>

        In Spring 2022, I aim to continue my work on understanding the reference paper further and a multi-sensor based approach for autonomous parking using the Husky robot.
        <br/><br/>
        Apart from this, I have enrolled for Adaptive Control and Automonous Robotics this semster and those will go hand-in-hand in helping me out in this project.

        <h3>News</h3>
          <ul>
            <li><b>Jan 2022</b>: Became Graduate Teaching Assistant for <a href="https://www.ece.gatech.edu/courses/course_outline/ECE3741">ECE3741</a> at Georgia Tech</li><hr/>
            <li><b>Aug 2021</b>: Started MS in ECE at Georgia Tech (in Metz, France)</li><hr/>
            <li><b>Jun 2020</b>: Started as a Fullstack Associate Developer at GMetri</li><hr/>
            <li><b>Jan 2020</b>: Started as a Technology Intern at GMetri</li><hr/>
            <li><b>Jul 2019</b>: Presented a paper on Analysis of Fake News in Social Media at SIGKDD Workshop, Alaska</li><hr/>
            <li><b>Jan 2019</b>: Became Undergraduate Teaching Assistant for Microcontrollers at VIT</li><hr/>
            <li><b>Jul 2018</b>: Became Executive Board Member at VIThink, an AI Research Forum at VIT</li><hr/>
            <li><b>May 2018</b>: Started as a Research and Development Intern at PTC</li><hr/>
            <li><b>Jan 2018</b>: Became Team Lead at VITeach at VIT</li><hr/>
            <li><b>May 2017</b>: Started as a Product Development Intern at Hasura</li><hr/>
            <li><b>Feb 2017</b>: Started volunteering at social outreach club for education of underpriviledge children</li><hr/>
            <li><b>Jun 2016</b>: Started bachelors in Electronics Engineering at Vellore Institute of Technology (VIT)</li><hr/>
          </ul>

        </div>
      </header>
    </div>
  );
}

export default App;
